function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Add Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.9998,0.4999 C8.27594237,0.4999 8.4998,0.723757625 8.4998,0.9999 L8.4998,7.4999 L14.9998,7.4999 C15.2759424,7.4999 15.4998,7.72375763 15.4998,7.9999 C15.4998,8.27604237 15.2759424,8.4999 14.9998,8.4999 L8.4998,8.4999 L8.4998,14.9999 C8.4998,15.2760424 8.27594237,15.4999 7.9998,15.4999 C7.72365763,15.4999 7.4998,15.2760424 7.4998,14.9999 L7.4998,8.4999 L0.9998,8.4999 C0.723657625,8.4999 0.4998,8.27604237 0.4998,7.9999 C0.4998,7.72375763 0.723657625,7.4999 0.9998,7.4999 L7.4998,7.4999 L7.4998,0.9999 C7.4998,0.723757625 7.72365763,0.4999 7.9998,0.4999 Z",
  id: "add-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "add-Icon/Global/Add",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-Swatches/DarkGreen",
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "add-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#add-path-1"
})));

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.d6fe916f.svg";
export { ForwardRef as ReactComponent };